import React from 'react';
import { LinkProps } from '../../interfaces';
import { StyledLink } from './styles';

const Link: React.FC<LinkProps> = (props: LinkProps) => (
  <StyledLink
    {...props}
    data-cy={props.dataCy}
    data-testid={props.dataTestId}
    onClick={props.onClick}
  >
    {props.children}
  </StyledLink>
);

export default Link;
